import { render, staticRenderFns } from "./formBlock.vue?vue&type=template&id=704c563b&"
import script from "./formBlock.vue?vue&type=script&lang=babel&"
export * from "./formBlock.vue?vue&type=script&lang=babel&"
import style0 from "./formBlock.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VLazy } from 'vuetify/lib/components/VLazy';
installComponents(component, {VCard,VCardSubtitle,VContainer,VDivider,VLazy})
